import {
    GET_LIST_DOCUMENT_CATEGORIES,
    REMOVE_DOCUMENT_CATEGORIES,
    GET_DOCUMENT_CATEGORIES_ACTIVE
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    document_categories: [],
    document_categories_active: [],
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_DOCUMENT_CATEGORIES: {
            return {
                ...state,
                document_categories: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload?.current_page || 1, 10),
                    total: parseInt(action.payload?.total || 0, 10),
                    perPage: parseInt(action.payload?.per_page || 30, 10),
                }
            }
        }
        case GET_DOCUMENT_CATEGORIES_ACTIVE: {
            return {
                ...state,
                document_categories_active: action.payload || [],
            }
        }

        case REMOVE_DOCUMENT_CATEGORIES: {
            const temp = state.document_categories.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });

            const temp2 = state.document_categories_active.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, document_categories: temp, document_categories_active: temp2 };
        }
        default: return state;
    }
}
